import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { HomePolicy } from '@models/swagger';
import { GetPolicyParams } from './service';

export enum GetPolicyActions {
  Failure = '[Policy GetPolicy] Failure',
  Request = '[Policy GetPolicy] Request',
  Success = '[Policy GetPolicy] Success',
}

export const GetPolicyFailure = createAction(GetPolicyActions.Failure, props<{ error: HttpErrorResponse }>());

export const GetPolicyRequest = createAction(GetPolicyActions.Request, props<{ parameters: GetPolicyParams }>());

export const GetPolicySuccess = createAction(GetPolicyActions.Success, props<{ data: HomePolicy }>());
